<script lang="ts" setup>
import { onMounted } from 'vue';
import { isMobile } from '@/utils';
import { useUpgradeBrowserData } from '@/composables/useUpgradeBrowserData';

const { isShow, downloadUrl, check, close } = useUpgradeBrowserData();

onMounted(() => {
  check();
});
</script>

<template>
  <div v-if="!isMobile && isShow" class="info-box" ref="browserInfo">
    <div class="info max-main clearfloat">
      <div class="box-l">
        <img src="@/assets/images/common/Google-Chrome-icon.png" alt="" />
        <div class="title">Google Chrome</div>
        <div class="des">建议使用Chrome浏览器访问本站，以获得更好的体验。</div>
      </div>
      <div class="box-r btn-box">
        <a href="javascript:;" class="no" @click="close">不用了，谢谢</a>
        <a class="yes" :href="downloadUrl">下载</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 更换浏览器提示 */
.info-box {
  font-family: 'Microsoft YaHei', '微软雅黑';
  line-height: 1.4;
  z-index: 99;
  display: block;
  background-color: rgb(246, 246, 246);
  height: 72px;
}
.info-box .info {
  height: 60px;
  padding-top: 17px;
  display: flex;
  justify-content: space-around;
}
.info-box .box-l {
  padding: 0 15px;
  width: 66.66%;
  float: left;
}
.info-box .box-r {
  padding: 0 15px;
  width: 33.33%;
  float: left;
}
.info-box img {
  float: left;
  margin-right: 12px;
  height: 40px;
  width: 40px;
}
.info-box .title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.info-box .des {
  font-size: 13px;
  color: #000;
  opacity: 0.7;
}
.info-box .btn-box {
  text-align: right;
  margin-top: 10px;
}
.info-box a {
  display: inline-block;
  padding: 0 20px;
  font-size: 13px;
  line-height: 30px;
}
.info-box .no {
  text-decoration: underline;
  color: #000;
  opacity: 0.5;
}
.info-box .no:hover {
  color: #3956eb;
}
.info-box .yes {
  background: #3956eb;
  color: #fff;
  border-radius: 3px;
  text-decoration: none;
}
/* /更换浏览器提示 */
</style>
